/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import { loanService } from '../../../../api/services/loanService';
import {
  setAllActiveLoans,
  setAllActiveLoansLoader,
} from '../../../../infra/aggregates/myProfile/loansAggregates/activeLoansSlice';

interface PropsValues {
  setLoansAppliedData: (data: any) => void;
}

function DTOActiveLoans({ setLoansAppliedData }: PropsValues) {
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state.authSlice);
  const storeActiveLoans = useAppSelector(
    (state) => state.activeLoansSlice.activeLoans,
  );
  async function getAllActiveLoans(empId: number) {
    dispatch(setAllActiveLoansLoader(true));
    const response = await loanService.getActiveLoans(empId);
    if (response) {
      dispatch(setAllActiveLoans(response?.data));
      setLoansAppliedData(response?.data);
      dispatch(setAllActiveLoansLoader(false));
    } else {
      dispatch(setAllActiveLoansLoader(false));
      return;
    }
  }
  useEffect(() => {
    if (selector.emp_id) getAllActiveLoans(selector.emp_id);
  }, []);

  useEffect(() => {
    setLoansAppliedData(storeActiveLoans);
  }, [storeActiveLoans]);

  return <></>;
}
export default DTOActiveLoans;
